module.exports = __webpack_public_path__ + "static/media/CCTP -  Health and Fitness Teacher_s Guide (v1)_.87deb73e.pptx";